import React from 'react';
import PropTypes from 'prop-types';
import {
	makeStyles,
	Button
} from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const styles = makeStyles(theme => ({
    background: {
        // backgroundColor: "#B3D8DD"
    }
}));

const ActionButton = React.forwardRef((props, ref) => {
    let classes = styles(),
        { children, action, color, label, disabled, icon, iconRotation, handleClick, ...rest } = props;

    return (
        <Button
            className={classes.background}
            fullWidth
            variant="outlined"
            text={action.label}
            color={action.color}
            disabled={action.disabled}
            onClick={e => action.handleClick(e)}
            aria-label={`${action.label} Activity`}>
            <FontAwesomeIcon
                size="lg"
                icon={action.icon}
                rotation={action.iconRotation}
                style={{ marginRight: '5px' }}
                title={`${action.label} Activity`} />
            {action.label}
        </Button>
    );
});

ActionButton.propTypes = {
    color: PropTypes.string,
    text: PropTypes.string,
    contained: PropTypes.bool,
    labelClassName: PropTypes.string,
    textClassName: PropTypes.string,
    children: PropTypes.any
};

ActionButton.displayName = "ActionButton";
export default ActionButton;
